"use strict";

require("core-js/modules/es6.string.link");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetState = exports.exportCode = exports.updateState = exports.deleteItem = exports.updateItem = exports.addItem = void 0;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var addItem = function addItem() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? '' : _ref$link,
      _ref$img = _ref.img,
      img = _ref$img === void 0 ? '' : _ref$img,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? '' : _ref$alt,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? '' : _ref$text,
      _ref$collapsed = _ref.collapsed,
      collapsed = _ref$collapsed === void 0 ? false : _ref$collapsed,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'banner' : _ref$type;

  return {
    type: 'ADD_ITEM',
    payload: {
      link: link,
      img: img,
      alt: alt,
      text: text,
      collapsed: collapsed,
      type: type
    }
  };
};

exports.addItem = addItem;

var updateItem = function updateItem(banner) {
  return {
    type: 'UPDATE_ITEM',
    payload: _objectSpread({}, banner)
  };
};

exports.updateItem = updateItem;

var deleteItem = function deleteItem(id) {
  return {
    type: 'DELETE_ITEM',
    payload: {
      id: id
    }
  };
};

exports.deleteItem = deleteItem;

var updateState = function updateState(state) {
  return {
    type: 'UPDATE_STATE',
    payload: _objectSpread({}, state)
  };
};

exports.updateState = updateState;

var exportCode = function exportCode() {
  return {
    type: 'EXPORT_CODE',
    payload: {}
  };
};

exports.exportCode = exportCode;

var resetState = function resetState() {
  return {
    type: 'RESET_STATE',
    payload: {}
  };
};

exports.resetState = resetState;